<template>
  <div :style="mainContainerStyles" v-loading="bLoading">
    <template v-if="bLoadError">
      <template v-if="bStorefrontNotFound">
        <StorefrontNotFoundMessage />
      </template>
      <template v-else>
        <ErrorMessage
          title="Well, this is embarrassing"
          message="Something went wrong looking up products for this shop."
        >
          <slot name="messageSuffix">
            <el-button
              type="text"
              class="mt-4"
              style="padding:0"
              @click="init()"
            >
              Try again?
            </el-button>
          </slot>
        </ErrorMessage>
      </template>
    </template>
    <template v-else>
      <template v-if="!bLoading">
        <template v-if="!storefrontHasValidLicense">
          <StorefrontDisabledMessage class="mt-4" />
        </template>
        <template v-else-if="!storefrontIsActive">
          <StorefrontDisabledMessage class="mt-4" />
        </template>
        <template v-else-if="!storefrontHasProductsForSale" >
          <NoProductsMessage class="mt-4" />
        </template>
        <template v-else-if="!isStripeConnectOk">
          <StorefrontDisabledMessage class="mt-4" />
        </template>
        <template v-else>
          <ProductList :arrProducts="arrProducts"></ProductList>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import ProductList from "@/modules/shop/components/ProductList.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import NoProductsMessage from "@/modules/shop/messages/NoProductsMessage.vue";
import ErrorMessage from "@/modules/shop/messages/ErrorMessage.vue";
import StorefrontNotFoundMessage from "@/modules/shop/messages/StorefrontNotFoundMessage.vue";
import { httpStatusException } from "../../api";
import StorefrontDisabledMessage from "./messages/StorefrontDisabledMessage";
import Branding from "@/modules/shop/components/layout/Branding";
export default {
  components: {
    Branding,
    StorefrontDisabledMessage,
    NoProductsMessage,
    ErrorMessage,
    StorefrontNotFoundMessage,
    ProductList
  },
  data() {
    return {
      bLoading: true,
      bLoadError: false,
      bStorefrontNotFound: false,
      strStorefrontShortcode: ""
    };
  },
  props: {},
  computed: {
    // map store state to local computed properties:
    ...mapState({
      // id: state => state.book.id
    }),
    // map store getters to local computed properties:
    ...mapGetters([
      "getStorefront",
      "getProducts",
      "storefrontIsActive",
      "storefrontHasValidLicense",
      "storefrontHasProductsForSale",
      "storefrontUseStripeConnect",
      'storefrontIsStripeConnectOk',
      "uiCartIconIsShowingOrderInfo",
      "userIsLoggedIn",
      "getUserDisplayName"
    ]),
    oStorefront() {
      return this.getStorefront;
    },
    arrProducts() {
      return this.getProducts;
    },
    isStripeConnectOk () {
      if (!this.storefrontUseStripeConnect) return true;
      return this.storefrontIsStripeConnectOk;
    },
    mainContainerStyles() {
      const styles = {
        flex: "1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      };
      return styles;
    },
    bShowShoppingCartIcon() {
      let showCartIcon = false;
      // only show the cart icon if the route tells us we should
      if (this.$route.meta && this.$route.meta.showCartIcon === true) {
        showCartIcon = true;
      }
      return !this.bLoadError && showCartIcon;
    }
  },
  methods: {
    // map component methods to store.dispatch calls
    ...mapActions(["getStorefrontCatalog"]),
    // here we're going to load the storefront catalogue
    // if the store load loads and there's products to show, we'll
    // enable the router view
    // otherwise, we'll show a useful message for what went wrong
    init: async function() {
      this.bLoading = true;
      this.bLoadError = false;
      this.bStorefrontNotFound = false;
      try {
        await this.getStorefrontCatalog(this.strStorefrontShortcode);
      } catch (err) {
        if (err instanceof httpStatusException) {
          if (err.httpCode === 404) {
            this.bStorefrontNotFound = true;
          }
        }
        this.bLoadError = true;
      } finally {
        this.bLoading = false;
      }
    },
    onLogoClick() {
      this.$router.push({ name: "storefront" });
    }
  },
  mounted() {
    this.strStorefrontShortcode = this.$route.params.id;
    this.init();
  }
};
</script>
